import { ACHFormValues } from 'adminSignUp/common/ACHPayment'

export const convertRecurlyErrorsToMap = (err: any): Map<string, string> => {
  let errorsAsMap = new Map<string, string>()
  err.details.forEach((c: any) => {
    errorsAsMap.set(c.field, c.messages.join(','))
  })
  return errorsAsMap
}

export const getCreditCardToken = (id?: string) => {
  const form = document.getElementById(id || 'recurly-form')
  return new Promise<any>((resolve, reject) => {
    recurly.token(form, async (err: any, token: any) => {
      if (err) {
        reject(convertRecurlyErrorsToMap(err))
      } else {
        resolve(token.id)
      }
    })
  })
}

export const getAchToken = (achPaymentValues: ACHFormValues) => {
  const billingInfo = {
    routing_number: achPaymentValues.bankRoutingNumber,
    account_number: achPaymentValues.accountNumber,
    account_number_confirmation: achPaymentValues.accountNumberConfirmation,
    account_type: achPaymentValues.bankAccountType,
    name_on_account: achPaymentValues.nameOnAccount,
    country: 'US',
  }

  return new Promise<any>((resolve, reject) => {
    recurly.bankAccount.token(billingInfo, async (err: any, token: any) => {
      if (err) {
        reject(convertRecurlyErrorsToMap(err))
      } else {
        resolve(token.id)
      }
    })
  })
}
